module.exports = __webpack_public_path__ + "media/images/login-computer-d4fdfefd3c7dffb6c39a52c2ad682ad9.svg";